import { PortalDisabledColor, PortalPrimaryColor, PortalSecondaryColor, PortalTheme } from "./Enums";

export class WindowObject {
    ID: string;
    NAME: string;
    URL: string;
    LOGO_URL: string;
    THEME_COLOR: PortalTheme;

    constructor(value: any = {}) {
        Object.assign(this, value);
    }

    getPrimaryColor(): string {
        let color = '';
        switch (this.THEME_COLOR) {
            case PortalTheme.DEFAULT:
                color = PortalPrimaryColor.DEFAULT;
                break;
            case PortalTheme.NIGHT_BLUE:
                color = PortalPrimaryColor.NIGHT_BLUE;
                break;
            case PortalTheme.PURPLE:
                color = PortalPrimaryColor.PURPLE;
                break;
            case PortalTheme.TIFFANY_BLUE:
                color = PortalPrimaryColor.TIFFANY_BLUE;
                break;
            case PortalTheme.JUNGLE_GREEN:
                color = PortalPrimaryColor.JUNGLE_GREEN;
                break;
            case PortalTheme.HONEY_YELLOW:
                color = PortalPrimaryColor.HONEY_YELLOW;
                break;
            default:
                color = PortalPrimaryColor.DEFAULT;
                break;
        }
        return color;
    }

    getSecondaryColor(): string {
        let color = '';
        switch (this.THEME_COLOR) {
            case PortalTheme.DEFAULT:
                color = PortalSecondaryColor.DEFAULT;
                break;
            case PortalTheme.NIGHT_BLUE:
                color = PortalSecondaryColor.NIGHT_BLUE;
                break;
            case PortalTheme.PURPLE:
                color = PortalSecondaryColor.PURPLE;
                break;
            case PortalTheme.TIFFANY_BLUE:
                color = PortalSecondaryColor.TIFFANY_BLUE;
                break;
            case PortalTheme.JUNGLE_GREEN:
                color = PortalSecondaryColor.JUNGLE_GREEN;
                break;
            case PortalTheme.HONEY_YELLOW:
                color = PortalSecondaryColor.HONEY_YELLOW;
                break;
            default:
                color = PortalSecondaryColor.DEFAULT;
                break;
        }
        return color;
    }

    getDisabledColor(): string {
        let color = '';
        switch (this.THEME_COLOR) {
            case PortalTheme.DEFAULT:
                color = PortalDisabledColor.DEFAULT;
                break;
            case PortalTheme.NIGHT_BLUE:
                color = PortalDisabledColor.NIGHT_BLUE;
                break;
            case PortalTheme.PURPLE:
                color = PortalDisabledColor.PURPLE;
                break;
            case PortalTheme.TIFFANY_BLUE:
                color = PortalDisabledColor.TIFFANY_BLUE;
                break;
            case PortalTheme.JUNGLE_GREEN:
                color = PortalDisabledColor.JUNGLE_GREEN;
                break;
            case PortalTheme.HONEY_YELLOW:
                color = PortalDisabledColor.HONEY_YELLOW;
                break;
            default:
                color = PortalDisabledColor.DEFAULT;
                break;
        }
        return color;
    }

}
